<template>
  <div class="my-member">
    <div class="my-member-header" :class="headerClass[userVipData.vipLevel]">
      <div class="my-member-bg"></div>
      <div class="my-member-info">
        <div
          class="upgrade-member"
          @click="upgradeMember"
          v-if="userVipData.vipLevel != 0 && userVipData.vipLevel != 4"
          >升级会员</div
        >

        <img
          v-if="userVipData.vipLevel == 0"
          src="../../assets/member-icon/member-0.png"
          class="my-member-info-bg"
          alt=""
        />
        <img
          v-if="userVipData.vipLevel == 1"
          src="../../assets/member-icon/member-1.png"
          class="my-member-info-bg"
          alt=""
        />
        <img
          v-if="userVipData.vipLevel == 2"
          src="../../assets/member-icon/member-2.png"
          class="my-member-info-bg"
          alt=""
        />
        <img
          v-if="userVipData.vipLevel == 3"
          src="../../assets/member-icon/member-3.png"
          class="my-member-info-bg"
          alt=""
        />
        <img
          v-if="userVipData.vipLevel == 4"
          src="../../assets/member-icon/member-4.png"
          class="my-member-info-bg"
          alt=""
        />
        <div class="member-info-box">
          <div class="member-info-left">当前等级</div>
          <div class="member-info-title">{{ userVipData.vipName }}</div>
          <div class="member-time">{{ userVipData.vipEndTime }}</div>
          <div class="next-member" v-if="userVipData.nextVipName">
            {{ userVipData.nextVipName }} {{ userVipData.nextVipBeginTime }}生效
          </div>
        </div>
        <div class="info-box">
          <div class="info-flex">
            <div class="info-value">{{ userVipData.chargeTime || 0 }}</div>
            <div class="info-name">已优惠充电(次)</div>
          </div>
          <div class="info-flex">
            <div class="info-value">
              {{ userVipData.chargeDiscountAmount || 0 }}
            </div>
            <div class="info-name">已优惠金额(元)</div>
          </div>
          <div
            class="info-flex"
            v-if="userVipData.vipLevel != 0 && userVipData.vipLevel != 4"
          >
            <div class="info-value">
              {{ userVipData.chargeDiscountByNextLevelAmount || 0 }}
            </div>
            <div class="info-name">下一等级预估优惠金额(元)</div>
          </div>
        </div>
        <img
          class="three-icon"
          src="../../assets/member-icon/three.png"
          alt=""
        />
      </div>
      <div class="my-member-text" v-if="userVipData.vipLevel == 0">
        当前无优惠，开通即享受优惠
      </div>
      <div class="my-member-text" v-else>
        尊贵的{{ userVipData.vipName }}，您享有充电{{
          userVipData.discountAmountTypelDesc
        }}{{ (userVipData.discountRatio * 10) | toFixed }}折优惠
      </div>
    </div>
    <div class="member-purchase">
      <div class="member-purchase-title">
        <div class="title" @click="popupShow = true">
          会员购买
          <img class="wen" src="../../assets/img/wen.png" alt="" />
        </div>
        <div class="title-flex" @click="purchaseRecords">购买记录</div>
      </div>
      <div class="member-list">
        <template v-for="(item, index) in vipList">
          <div
            class="member-item"
            v-if="item.status"
            @click="vipClick(item)"
            :class="'member-item-' + item.vipLevel"
            :key="index"
          >
            <template v-if="item.vipLevel == 1">
              <img
                class="member-item-bg"
                v-if="userVipData.vipLevel <= item.vipLevel"
                src="../../assets/member-icon/member-icon-1.png"
                alt=""
              />
              <img
                class="member-item-bg"
                v-else
                src="../../assets/member-icon/member-icon-1-no.png"
                alt=""
              />
            </template>
            <template v-if="item.vipLevel == 2">
              <img
                class="member-item-bg"
                v-if="userVipData.vipLevel <= item.vipLevel"
                src="../../assets/member-icon/member-icon-2.png"
                alt=""
              />
              <img
                class="member-item-bg"
                v-else
                src="../../assets/member-icon/member-icon-2-no.png"
                alt=""
              />
            </template>
            <template v-if="item.vipLevel == 3">
              <img
                class="member-item-bg"
                v-if="userVipData.vipLevel <= item.vipLevel"
                src="../../assets/member-icon/member-icon-3.png"
                alt=""
              />
              <img
                class="member-item-bg"
                v-else
                src="../../assets/member-icon/member-icon-3-no.png"
                alt=""
              />
            </template>
            <template v-if="item.vipLevel == 4">
              <img
                class="member-item-bg"
                src="../../assets/member-icon/member-icon-4.png"
                alt=""
              />
            </template>
            <img
              class="active-icon"
              v-if="item.vipLevel == activeVip"
              src="../../assets/member-icon/member-active.png"
              alt=""
            />
            <div class="member-item-info">
              <div class="item-title">{{ item.vipName }}</div>
              <div class="item-value">
                {{ item.discountAmountTypeDesc
                }}{{ (item.discountRatio * 10) | toFixed }}折
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="member-day-list">
        <div
          class="member-day-item"
          @click="userPriceClick(item)"
          :class="{ active: userPriceActive == item.days }"
          v-for="item in userPriceParams"
          :key="item.days"
        >
          <div class="member-day-text">{{ item.daysDesc }}</div>
          <div class="member-day-info">
            <div class="day-money">{{ item.price }}元</div>
            <div class="day-money-text" v-if="item.firstDiscountRatio">
              首次购买{{ (item.firstDiscountRatio * 10) | toFixed }}折
            </div>
          </div>
        </div>
      </div>
      <div class="btn-box">
        <!-- <div class="btn-text">开通即视为同意<span class="text-a">《派诺会员用户协议》</span></div> -->
        <pi-button
          v-if="priceObj.originalPrice >= 0"
          :type="loading ? 'loading' : 'primary'"
          block
          @click="confirmClick(1, priceObj.originalPrice)"
        >
          ¥{{ priceObj.originalPrice }} 立即购买
          <!-- <div class="sub-tips" v-if="priceObj.priceDiff != null">
            待当前会员等级到期后，才可使用新的会员等级
          </div> -->
        </pi-button>
        <pi-button v-else type="default" block> 立即购买 </pi-button>
        <!-- <pi-button
          v-if="priceObj.priceDiff != null"
          :type="loading ? 'loading' : 'primary'"
          class="tow-sub"
          block
          @click="confirmClick(2, priceObj.priceDiff)"
        >
          ¥{{ priceObj.priceDiff }} 立即购买
          <div class="sub-tips">
            补{{ priceObj.priceDiff }}元差价，直接升级当前会员等级，可立即使用
          </div>
        </pi-button> -->
      </div>
    </div>
    <van-popup v-model="popupShow" class="popup-tips">
      <div class="popup-content">
        <p class="popup-content-p">
          1、不同会员级别享受会员权益不同，请仔细阅读全部权益中的各等级会员优惠信息
        </p>
        <p class="popup-content-p">
          2、会员等级优惠充电仅针对个人会员，不能与企业会员优惠并行使用
        </p>
        <p class="popup-content-p">
          3、购买会员等级充电优惠可同时与各种活动优惠双重或多重优惠
        </p>
        <p class="popup-content-p">
          4、会员等级购买后不能退购，重复购买将延长会员时长
        </p>
        <p class="popup-content-p">
          5、已购买某个等级会员后不能在购买其他等级会员，比当前等级高的还是可以购买的
        </p>
        <pi-button type="primary" @click="onClose" block size="small"
          >我知道了</pi-button
        >
      </div>
    </van-popup>
  </div>
</template>
<script>
import { Popup } from "vant";
import {
  getUserVipList,
  getUserVipByUser,
  getUserVipListDetails,
  purchaseUserVip,
  getUserVipPrice,
} from "../../common/api";

export default {
  name: "my-member",
  components: {
    [Popup.name]: Popup,
  },
  data() {
    return {
      headerClass: {
        0: "",
        1: "vip-1",
        2: "vip-2",
        3: "vip-3",
        4: "vip-4",
      },
      vip: 4,
      userVipData: {
        vipLevel: 0,
        vipName: "普通会员",
      },
      vipList: [],
      activeVip: "",
      activeVipObj: {},
      userPriceParams: [],
      userPriceActive: "",
      userPriceActiveObj: {},
      priceObj: {},
      loading: false,
      popupShow: false,
    };
  },
  mounted() {
    this.getUserVipByUser();
  },
  methods: {
    onClose() {
      this.popupShow = false;
    },
    purchaseRecords() {
      this.$router.push(
        "purchase-records?chargeUserPkId=" + this.$route.query.chargeUserPkId
      );
    },
    async getUserVipByUser() {
      let ret = await getUserVipByUser({
        // accountPkId: this.$route.query.accountPkId
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.userVipData = ret.data[0] || {};
      } else {
        this.$toast(ret.msg);
      }
      this.getUserVipList();
    },
    async getUserVipList() {
      let ret = await getUserVipList({});
      if (ret.status === this.$config.ajaxStatus) {
        this.vipList = ret.data || [];

        //this.userVipData    
        let itemData = null;
        this.vipList.map((item) => {
          if (
            this.userVipData.vipLevel <= item.vipLevel &&
            !itemData &&
            item.status
          ) {
            itemData = item;
          }
        });
        if (itemData) {
          this.vipClick(itemData);
        }
      } else {
        this.$toast(ret.msg);
      }
    },
    async getUserVipListDetails(vipPkId) {
      this.userPriceParams = [];
      let ret = await getUserVipListDetails({
        vipPkId: vipPkId,
      });
      if (ret.status === this.$config.ajaxStatus) {
        if (ret.data && ret.data[0]) {
          this.userPriceParams = ret.data[0].userPriceParams || [];
          if (this.userPriceParams[0]) {
            this.userPriceClick(this.userPriceParams[0]);
          }
        }
      } else {
        this.$toast(ret.msg);
      }
    },
    async purchaseUserVip(purchaseType, price) {
      this.loading = true;
      let ret = await purchaseUserVip({
        chargeUserPkId: this.$route.query.chargeUserPkId,
        discountAmountType: this.activeVipObj.discountAmountType,
        discountRatio: this.activeVipObj.discountRatio,
        vipLevel: this.activeVipObj.vipLevel,
        // firstTimePrice: this.userPriceActiveObj.price,
        points: this.userPriceActiveObj.points,
        price: price,
        vipDays: this.userPriceActiveObj.days,
        purchaseType: purchaseType,
        purchaseWay: 1,
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.$toast("购买成功");
        this.getUserVipByUser();
      } else {
        this.$toast(ret.msg);
      }
      this.loading = false;
    },
    async getUserVipPrice() {
      let ret = await getUserVipPrice({
        vipGoodsPkId: this.userPriceActiveObj.vipGoodsPkId,
        // days: this.userPriceActiveObj.days,
        // price: this.userPriceActiveObj.price,
        // vipLevel: this.activeVipObj.vipLevel,
        // vipName: this.activeVipObj.vipName,
        // vipPkId: this.activeVipObj.vipPkId,
        // firstDiscountRatio: this.userPriceActiveObj.firstDiscountRatio
      });
      if (ret.status === this.$config.ajaxStatus) {
        this.priceObj = ret.data[0] || {};
      } else {
        this.$toast(ret.msg);
      }
    },
    vipClick(item) {
      // if (this.userVipData.vipLevel <= item.vipLevel) {
      if(item.status){
        this.activeVip = item.vipLevel;
        this.activeVipObj = item;
        this.getUserVipListDetails(item.vipPkId);
      }
    },
    userPriceClick(item) {
      this.userPriceActive = item.days;
      this.userPriceActiveObj = item;
      // if(this.userVipData.vipLevel != 0 && this.userVipData.vipLevel < this.activeVip){
      // 不是普通会员，想升级会员，有补差价
      this.getUserVipPrice();
      // }
    },
    confirmClick(purchaseType, money) {
      this.$dialog
        .confirm({
          message: "确定要使用余额购买该会员吗",
          confirmButtonText: "确定",
          confirmButtonColor: "#14CC80",
          closeOnPopstate: true,
        })
        .then(() => {
          this.$dialog
            .alert({
              message: '购买成功',
              confirmButtonText: "确认",
              confirmButtonColor: "#14CC80",
              closeOnPopstate: true,
            })
            .then(() => {
              this.purchaseUserVip(purchaseType, money);
            });
          
        })
        .catch(() => {
          // on cancel
        });
    },
    upgradeMember() {
      this.$router.push("/my-member-upgrade?chargeUserPkId=" +  this.$route.query.chargeUserPkId);
    },
  },
};
</script>
<style lang="less">
@import url('./css/my-member.less');

</style>
